export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: 'yegoo-market',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  /**
   * @description api请求基础路径
   */
  // baseUrl: {
  //   dev: '',
  //   pro: ''
  // },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'Home',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  },

  couponTypeList: [
    {value: 'DISCOUNT', label: '折扣'},
    {value: 'REDUCTION', label: '满减'},
    {value: 'DEDUCTION', label: '抵扣'}
  ],
  couponDateType: [{value: 'DAY', label: '按天数'}, {value: 'DATE', label: '固定日期'}],
  NormalSelects: [{value: 'YES', label: '是'}, {value: 'NO', label: '否'}],
  imgUrl: process.env.NODE_ENV === 'development' ? '/api/admin/upload' : '/admin/upload',
  imgUrlZip: process.env.NODE_ENV === 'development' ? '/api/admin/offline-photos-wall/upload' : '/admin/offline-photos-wall/upload',
  videoUrl: process.env.NODE_ENV === 'development' ? '/api/admin/uploadVideo' : '/admin/uploadVideo',
  apiUrl: process.env.NODE_ENV === 'development' ? '/api' : '',
  enumYesOrNo: [{value: 'YES', label: '是'}, {value: 'NO', label: '否'}],
  bargainStatus: [
    {label: '砍价中', value: 'BARGIN_PROCESS'},
    {label: '砍价成功', value: 'BARGIN_SUCCESS'},
    {label: '砍价失败', value: 'BARGIN_FAILURE'}
  ],
  bindStatusList: [
    {label: '已绑定', value: 'YES'},
    {label: '未绑定', value: 'NO'}
  ],
  pointRecordTypeList: [
    {label: '签到赠送', value: 'SIGNIN'},
    {label: '数据同步', value: 'DATA_SYNC'},
    {label: '人工修改', value: 'MANUAL_MODIFY'},
    {label: '下单返利', value: 'ORDER_REBATE'},
    {label: '注册赠送', value: 'REGISTER_GIVE'},
    {label: '使用扣除', value: 'ORDER_DEDUCT'},
    {label: '取消返回', value: 'CANCEL_RETURN'}
  ],
  orderStatusList: [
    {label: '已付款待使用', value: 'UNUSERD'},
    {label: '已付款未发货', value: 'PAY'},
    {label: '未付款', value: 'CREATE'},
    {label: '已发货待收货', value: 'SEND'},
    {label: '交易完成', value: 'FINISHED'},
    {label: '交易关闭', value: 'CLOSED'},
    {label: '验签失败', value: 'ATTESTATIONFAIL'}
  ],
  backOrderStatusList: [
    {label: '退款审核中', value: 'REFUND_REVIEW'},
    {label: '拒绝退款申请', value: 'REFUESED'},
    {label: '退单成功', value: 'CLOSED'}
  ],
  trueClientList: [
    {label: '是', value: 'YES'},
    {label: '否', value: 'NO'}
  ]
}



// WEBPACK FOOTER //
// ./src/config/index.js